import {
  ANSWER_VALUE,
  ANSWER_DESCRIPTION,
  IMAGE,
} from "../utilities/Constants";
import API from "../../services/http-helper.service";
import { BASE64_PATTERN } from "../../utility/CommonUtils";

//All Extract answer functions should be written here
export const isValid = (answer) => {
  if (typeof answer === "object" && answer !== null) {
    return true;
  } else {
    return answer && answer.length > 0;
  }
};

export const extractTextAnswerValue = (answer) => {
  if (isValid(answer)) {
    let userResponse = answer[0]; //text - array will contain exact one value.
    return userResponse ? userResponse.answerValue : undefined;
  }

  return undefined;
};

export const extractDateHoursValue = (answer) => {
  if (isValid(answer)) {
    let date;
    let hours;
    let userResponse = answer[0];
    if (userResponse) {
      date = userResponse.answerValue ? userResponse.answerValue : "";
      hours = userResponse.answerDescription
        ? userResponse.answerDescription
        : "";
    } else {
      date = answer[ANSWER_VALUE];
      hours = answer[ANSWER_DESCRIPTION];
    }
    return {
      date: date,
      hours: hours,
    };
  }

  return undefined;
};

export const extractRangeValue = (answer) => {
  if (isValid(answer)) {
    if (Array.isArray(answer)) {
      if (answer[0][ANSWER_VALUE]) {
        return answer[0][ANSWER_VALUE];
      }
    }
  }
  return undefined;
};

export const extractBarcodeValue = (answer) => {
  if (isValid(answer)) {
    let userResponse = answer[0]; //Bar code - array will contain exact one value.
    return userResponse.answerValue;
  }

  return undefined;
};

export const extractCheckBoxValue = (answer) => {
  if (isValid(answer)) {
    let responses = [];
    answer.forEach((response) => {
      let value = response.answerValue;
      if (value) {
        responses.push(value);
      }
    });
    return responses;
  }
  return undefined;
};

export const extractCheckBoxIndices = (answer, checkboxOptions) => {
  let options = Object.assign([], checkboxOptions); // because element.options are 'readonly'
  if (isValid(answer)) {
    let responses = [];
    answer.forEach((response) => {
      let value = response.answerValue;
      let index = options.indexOf(value);
      if (value && index !== -1) {
        responses.push(index);
        delete options[index]; // For multiple occurrences with same label
      }
    });
    return responses;
  }
  return undefined;
};

export const extractDropDownValue = (answer) => {
  if (isValid(answer)) {
    let responses = [];
    if (Array.isArray(answer)) {
      // if answer is an array ---> Array [ {…} ]
      answer.forEach((item) => {
        if (!Array.isArray(item)) {
          // if item is an object --> {"createdBy": "dev",...}
          for (const [key, value] of Object.entries(item)) {
            if (key === ANSWER_VALUE) {
              if (typeof value === "string") {
                // if value is coming as string
                responses.push(value);
              } else if (typeof value === "object") {
                // if value is coming as object
                value.forEach((insideItem) => {
                  responses.push(insideItem.value);
                });
              }
            }
          }
        }
      });
      return responses;
    } else {
      // if answer is not an array ---> Object { 0: {…}, image: (1) […] }
      let answerValue = answer[0].answerValue;
      answerValue.forEach((insideItem) => {
        responses.push(insideItem.value);
      });
      return responses;
    }
  }
};

export const extractRadioValue = (answer) => {
  if (isValid(answer)) {
    let userResponse = answer[0]; //Radio - array will contain exact one value.
    if (typeof userResponse.answerValue === "object") {
      let userResponseAnswerValue = userResponse.answerValue;
      let answerVal;
      Object.keys(userResponseAnswerValue).forEach((key) => {
        if (key === "value") {
          answerVal = userResponseAnswerValue[key];
        }
      });
      return answerVal;
    } else if (typeof userResponse.answerValue === "string") {
      return userResponse.answerValue;
    }
  }
};

export const extractSignature = async (answer) => {
  if (isValid(answer)) {
    if (typeof answer === "string") {
      answer = JSON.parse(answer);
    }
    let response = answer[0]; //Signature - value will contain base-64 string for image and description name.
    if (isText(response.answerValue)) {
      return readTextFile(response);
    } else {
      let signature = response.answerValue;
      let name = response.answerDescription;
      return {
        signature: signature,
        name: name,
      };
    }
  }
  return undefined;
};

const readTextFile = async (response) => {
  let id = response.answerValue.split(".txt");
  let signature;
  try {
    let res = await API.get(`images/${id[0]}`);
    if (res.status === 200) {
      await fetch(res?.data?.attachments?.[0]?.file)
        .then((response) => response.text())
        .then((data) => (signature = data))
        .catch((err) => console.error(err));
    }
  } catch (e) {
    return null;
  }

  let name = response.answerDescription;
  return {
    signature: signature,
    name: name,
  };
};

const isText = (input) => {
  if (typeof input !== "string") return "unknown";
  const trimmedInput = input.trim().toLowerCase();
  if (trimmedInput.endsWith(".txt")) {
    return true;
  }
  return false;
};

export const extractImageValue = (answer) => {
  if (isValid(answer)) {
    if (!Array.isArray(answer)) {
      // Object --> { 0: {…}, image: (2) […] }
      if (answer[IMAGE]) {
        return answer[IMAGE];
      }
    } else {
      let image = answer[0].images; // Array --> [{image: Array [ {…}, {…}], comment: "" …}]
      if (image) {
        return image;
      }
    }
  }
  return undefined;
};

export const extractAiFlags = (answer) => {
  if (isValid(answer)) {
    const source = Array.isArray(answer) ? answer[0] : answer;
    if (source) {
      if (source.aiVerification && typeof source.aiVerification === "object") {
        const { status, message } = source.aiVerification;
        if (status !== undefined) {
          return {
            aiVerificationStatus: status,
            aiVerificationMessage: message || "",
          };
        }
      }
      if (source.aiVerificationStatus !== undefined) {
        return { aiVerificationStatus: source.aiVerificationStatus };
      }
    }
  }
  return {};
};

export const extractCommentValue = (answer) => {
  if (isValid(answer)) {
    let userResponse = answer[0];
    return userResponse?.comment;
  }
  return undefined;
};
